import { TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

function LoadingTableRows({ numberOfRow, numberOfColumn }) {
  return (
    <>
      {[...Array(numberOfRow).keys()].map(() => (
        <TableRow>
          {[...Array(numberOfColumn).keys()].map(() => (
            <TableCell size="small">
              <Skeleton animation="wave" height={30} width="100%" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default LoadingTableRows;
